import React, { useEffect, useState } from "react";
import { BlogPost } from "./BlogPost";
import { BlogSidebar } from "./BlogSidebar";
import firebase from "../../../firebase";
import "./blogPost.scss";
import { Spinner } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { Link, NavLink } from "react-router-dom";
import { BlogHome } from "./BlogHome";
import "./blogPost.scss";

export const BlogDetails = (props) => {
  const [loader, setLoader] = useState(false);
  const [posts, setPosts] = useState([]);

  const ref = firebase.collection("/blog");
  function getData() {
    ref.onSnapshot((data) => {
      const item = [];
      data.forEach((doc) => {
        item.push(doc.data());
      });
      setPosts(item);

      setLoader(true);
    });
  }
  // const getData = () => {
  //   const ref = firebase.collection("/blog");
  //   ref.onSnapshot((data) => {
  //     const item = [];
  //     data.forEach((doc) => {
  //       item.push(doc.data());
  //     });
  //     setLoader(true);
  //   });
  // };
  useEffect(() => {
    getData();
    window.scrollTo({
      top: 0,
      left: 0,
    });
  }, []);
  return (
    <div style={{ minHeight: "100vh" }}>
      <Helmet>
        <meta charSet="utf-8" name="CloudSocial Blog page" />
        <meta
          name="description"
          content="CloudSocial media management and marketing blogs cover the latest social media blogs for business to build a strategy for the social media channel."
        />
        <title>Social Media Management and Marketing Blogs</title>
      </Helmet>
      {loader ? (
        <div className="data-blog">
          <div>
            <BlogPost {...props} />
            {/* <BlogHome /> */}
          
          </div>
          <div className="tapDelete">
            <BlogSidebar />
          </div>
        </div>
      ) : (
        <div
          className="data-blog"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "90vh",
            width: "100vw",
          }}
        >
          <Spinner animation="border" variant="secondary" />
        </div>
      )}
      {/* <div style={{ display: "none" }}>
          <Link to="/blog/2">blog</Link>
        </div> */}
    </div>
  );
};
